import { ArrowTrendingUpIcon, ClockIcon, ShoppingCartIcon, SparklesIcon, StarIcon } from '@heroicons/vue/24/outline'

const ICONS = {
  'trending-up': ArrowTrendingUpIcon,
  clock: ClockIcon,
  cart: ShoppingCartIcon,
  star: StarIcon,
  sparkles: SparklesIcon
}

export const iconFor = key => ICONS[key] || SparklesIcon
